// TODO: Add propTypes
/* eslint-disable react/prop-types */
import React from 'react';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import { Formik } from 'formik';
import { useMutation } from '@apollo/client';
import { get as _get } from 'lodash';
import * as immutable from 'object-path-immutable';

import toast from 'helpers/toast';
import CCEvents, { EventNames } from '@companycam/companycam-events';

import Form from './Form';
import SnippetSchema from './formSchema';
import { Button } from '@companycam/slab-web';

import {
  CREATE_REPORT_TEXT_SNIPPET,
  TEXT_SNIPPET_QUERY,
} from '../gql/snippets.graphql';

defineMessages({
  createSuccessMsg: {
    id: 'SnippetEditor.create.createSuccessMsg',
    defaultMessage: 'Snippet Successfully Saved',
    description: 'Snippet create success message',
  },
  createErrorMsg: {
    id: 'SnippetEditor.create.createErrorMsg',
    defaultMessage: 'Could Not Create Snippet. Please try again',
    description: 'Snippet create error message',
  },
  save: {
    id: 'Common.save',
    defaultMessage: 'Save',
    description: 'Save button',
  },
  cancel: {
    id: 'Common.cancel',
    defaultMessage: 'Cancel',
    description: 'Cancel button',
  },
});

const Create = ({ selectedText, handleCancel, handleSelectSnippet, intl }) => {
  const { formatMessage } = intl;

  const [createSnippet] = useMutation(CREATE_REPORT_TEXT_SNIPPET, {
    update: (cache, result) => {
      const newSnippet = _get(
        result,
        'data.reportTextSnippetCreate.reportsTextSnippet',
      );
      const newSnippetObject = {
        ...newSnippet,
        __typename: 'ReportTextSnippet',
      };
      const oldQueryData = cache.readQuery({
        query: TEXT_SNIPPET_QUERY,
      });
      const newQueryData = immutable.insert(
        oldQueryData,
        'viewer.company.reportsTextSnippet.nodes',
        newSnippetObject,
        0,
      );

      cache.writeQuery({ query: TEXT_SNIPPET_QUERY, data: newQueryData });
    },
    onCompleted: (result) => {
      const newSnippet = _get(
        result,
        'reportTextSnippetCreate.reportsTextSnippet',
      );
      handleSelectSnippet(newSnippet);
      CCEvents.logEvent(EventNames.CREATE_SNIPPET);
      toast.success(
        formatMessage({ id: 'SnippetEditor.create.createSuccessMsg' }),
      );
    },
    onError: () => {
      toast.error(formatMessage({ id: 'SnippetEditor.create.createErrorMsg' }));
    },
  });

  const handleCreateSubmit = async (values) => {
    const { title, content } = values;

    createSnippet({
      variables: {
        input: {
          title,
          content,
        },
      },
    });
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  const FormHeader = () => (
    <React.Fragment>
      <h3>
        <FormattedMessage
          id="SnippetEditor.create.header"
          defaultMessage="New Snippet"
          description="Create snippet header"
        />
      </h3>
      <div>
        <Button size="small" style={{ marginRight: 8 }} onClick={handleCancel}>
          <FormattedMessage id="Common.cancel" />
        </Button>
        <Button color="primary" size="small" type="submit">
          <FormattedMessage id="Common.save" />
        </Button>
      </div>
    </React.Fragment>
  );

  const validation = SnippetSchema;

  return (
    <Formik
      initialValues={{ content: selectedText || '' }}
      onSubmit={handleCreateSubmit}
      validationSchema={validation}
    >
      {(formikProps) => (
        <Form {...formikProps} isCreating originalContent={selectedText || ''}>
          <FormHeader />
        </Form>
      )}
    </Formik>
  );
};

export default injectIntl(Create);
